var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.app_id + item.package_name,staticClass:"config-list-item"},[_c('FormItem',{key:item.app_id + item.package_name,ref:"formItemRef",refInFor:true,attrs:{"default-data":item,"deeplinkValidConfig":_vm.deeplinkValidConfig}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }